import { useContext, useEffect } from 'react';

import { GridContext } from 'contexts/GridContext';

import { ValidationContext } from 'contexts/ValidationContext';

interface NameProps {
  projectId?: string;
  isReviewMode?: boolean;
  defaultGridName?: string;
}

const Name = ({ projectId, isReviewMode = false, defaultGridName = 'Grid 1' }: NameProps) => {
  const { setIsGridNameValid, setGridNameErrorMessage } = useContext(ValidationContext);

  const { setGrid, isCloningGrid } = useContext(GridContext);

  useEffect(() => {
    if (isReviewMode || !projectId) return;

    setGrid((prevGrid) => ({
      ...prevGrid,
      name: isCloningGrid ? prevGrid.name : defaultGridName,
      description: isCloningGrid || prevGrid.description ? prevGrid.description : '',
    }));

    setIsGridNameValid(true);
    setGridNameErrorMessage('');
  }, [defaultGridName, isCloningGrid, isReviewMode, projectId, setGrid, setGridNameErrorMessage, setIsGridNameValid]);

  if (isReviewMode) return null;

  return null;
};

export default Name;
